export default "__VITE_ASSET__Cdn1te83__"